import accessComposition from "../Access/composition";

const internetComposition = {
  ...accessComposition,
  cliType: "internet",
  typeLabel: "Internet",
  viewURL: "viewInternetProfileConfig",
};

export default internetComposition;
